import type { DeviceType } from "./deviceType";

export const DEVICE_TYPES: Record<Uppercase<DeviceType>, DeviceType> = {
  NCU: "ncu",
  TCU: "tcu",
  HSU: "hsu",
} as const;
